
import React from 'react';

const ChallengesSection: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
            Challenges Faced In Choosing The Right Agency
          </h2>
          
          <div className="prose prose-lg max-w-none text-gray-700">
            <p className="mb-6">
              Choosing the right safety staffing agency is critical for ensuring workplace safety and compliance with regulatory standards. However, the selection process can be fraught with challenges requiring careful consideration. One of the primary issues is ensuring that the agency's personnel have the requisite qualifications, experience, and expertise.
            </p>
            
            <p className="mb-6">
              Working with an unqualified company can lead to several significant problems, impacting not just project timelines but also the overall safety culture of an organization.
            </p>
            
            <div className="bg-red-50 border-l-4 border-red-500 p-6 mb-8">
              <h3 className="text-xl font-semibold text-red-800 mb-4">
                Risks of Working with Unqualified Agencies:
              </h3>
              <ul className="space-y-3 text-red-700">
                <li className="flex items-start">
                  <i className="ri-alert-line text-red-500 mr-2 mt-1"></i>
                  Non-compliance with safety regulations
                </li>
                <li className="flex items-start">
                  <i className="ri-alert-line text-red-500 mr-2 mt-1"></i>
                  Increased risk of workplace accidents and injuries
                </li>
                <li className="flex items-start">
                  <i className="ri-alert-line text-red-500 mr-2 mt-1"></i>
                  Inadequate project safety oversight
                </li>
                <li className="flex items-start">
                  <i className="ri-alert-line text-red-500 mr-2 mt-1"></i>
                  Gaps in safety coverage and oversight
                </li>
              </ul>
            </div>
            
            <p className="mb-6">
              Another issue that can arise from working with an unqualified safety staffing agency is the lack of tailored solutions to meet specific project needs. Safety requirements can vary significantly across different industries and projects. An agency with limited experience across these fields may offer an approach that insufficiently addresses a project's unique safety challenges.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChallengesSection;
